import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconClose = () => (_jsxs("svg", { className: "oc-icon icon-close", viewBox: "0 0 14 14", width: "100%", height: "100%", children: [_jsx("line", { x1: "1", y1: "1", x2: "13", y2: "13" }), _jsx("line", { x1: "13", y1: "1", x2: "1", y2: "13" })] }));
export default IconClose;
